import { useAuth, AuthContextProps } from 'react-oidc-context';
import { createContext, useContext } from 'react';

// Context to track if AuthProvider is available
export const AuthAvailableContext = createContext<boolean>(false);

// Hook that returns auth if available, or null if not
export function useOptionalAuth(): AuthContextProps | null {
  const hasAuth = useContext(AuthAvailableContext);

  // Only call useAuth if provider is available
  if (!hasAuth) {
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useAuth();
}

// Check if realm is configured
export function hasRealmConfigured(): boolean {
  return !!localStorage.getItem('billing_realm');
}
